<template>
  <div>
    <BaseEmploymentsTable
      ref="tableRef"
      data-test="employments-updated-table"
      :query="query"
      :is-onboarded="false"
      :has-pending-contract-changes="true"
      :is-active-tab="isActiveTab"
      :bulk-actions="bulkActions"
    >
      <template #action="{ row }">
        <EmploymentActionColumnUpdated
          :row="row"
          @employment-updates-approved="$emit('employment-updates-approved')"
        />
      </template>
    </BaseEmploymentsTable>
  </div>
</template>

<script lang="ts" setup>
import { ref } from 'vue'
import { TypedQueryDocumentNode } from 'graphql/index'
import BaseEmploymentsTable from './BaseEmploymentsTable.vue'
import { DataTableBulkAction } from '@/components/GraphqlDataTable/types'
import { graphql } from '@/gql'
import EmploymentActionColumnUpdated from '@/components/GraphqlDataTable/columns/Employment/Partner/EmploymentActionColumnUpdated.vue'

defineProps<{ isActiveTab?: boolean }>()

const query = graphql(`
  query PartnerEmploymentsUpdatedQuery(
    $accounts: [ID!]
    $search: String
    $first: Int!
    $page: Int
    $orderBy: [EmploymentsOrderByClauseInput!]
    $startDateRange: DateRangeInput
    $endDateRange: DateRangeInput
    $hiringManagers: [ID!]
    $assignmentCompanies: [ID!]
    $locations: [String!]
  ) {
    employments(
      accounts: $accounts
      search: $search
      first: $first
      page: $page
      orderBy: $orderBy
      startDateRange: $startDateRange
      endDateRange: $endDateRange
      hiringManagers: $hiringManagers
      companies: $assignmentCompanies
      locations: $locations
      employerRecordStatus: [CHANGES_REQUESTED]
    ) {
      data {
        ...EmploymentWorkerColumn
        ...EmploymentJobColumn
        ...EmploymentContractColumn
        ...EmploymentStartDateColumn
        ...EmploymentEndDateColumn
        ...EmploymentLocationColumn
        ...EmploymentHiringManagerColumn
        ...EmploymentAssignmentCompanyColumn
        ...EmploymentActionColumnUpdated
      }
    }
  }
`) as TypedQueryDocumentNode

const tableRef = ref<InstanceType<typeof BaseEmploymentsTable> | null>(null)

const bulkActions: DataTableBulkAction[] = []

defineEmits<{
  'employment-updates-approved': []
}>()
</script>

<style scoped></style>
